"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pegasys = void 0;
exports.pegasys = {
    router: '0x017dAd2578372CAEE5c6CddfE35eEDB3728544C4',
    minichef: '0x27F037100118548c63F945e284956073D1DC76dE',
};
